import { TextField } from '@mui/material'
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from 'react'

import translateUtils from '../../../_helpers/translateUtils'

const Text = forwardRef((props, ref) => {
  useImperativeHandle(ref, () => ({
    isValid: () =>
      !(props.required && !value.length) &&
      !(props.maxLength && value.length > props.maxLength),
  }))
  const [value, setValue] = useState(props.value || '')
  useEffect(() => {
    let isValid = true
    if (props.required && !value.length) isValid = false
    // maxLength mirrors the server's AJV cap (alt fields: 125) — the input
    // hard-caps typing below, but a pre-existing over-long value must still
    // block submit instead of 400ing server-side.
    if (props.maxLength && value.length > props.maxLength) isValid = false
    props.setIsValids((s) => {
      s[props.index] = isValid
      return s
    })
    if (isValid)
      props.setIsValid(
        props.isValids.reduce((isAllValid, key, i) => {
          if (i === props.index) return isAllValid && isValid
          return isAllValid && key
        }, true)
      )
    else props.setIsValid(false)
    props.setBody((s) => ({ ...s, [props.name]: value }))
  }, [value])
  return (
    <TextField
      margin="normal"
      label={translateUtils.translate(props.label)}
      type="text"
      fullWidth
      InputLabelProps={{ shrink: true }}
      autoFocus={props.index === 0}
      value={value}
      onChange={(event) => setValue(event.target.value)}
      required={props.required}
      error={
        (props.required && !value.length) ||
        Boolean(props.maxLength && value.length > props.maxLength)
      }
      {...(props.maxLength && { inputProps: { maxLength: props.maxLength } })}
      {...(props.required &&
        !value.length && {
          helperText: `${translateUtils.translate(
            props.label
          )} ${translateUtils.translate('is required')}`,
        })}
      {...(props.maxLength &&
        (!props.required || value.length) && {
          helperText: `${value.length}/${props.maxLength}`,
        })}
      multiline
    />
  )
})
export default Text
